import { SiteConfig } from './initSite';

const { AuthHeader, SiteId, LoginLink, LogoutLink, WebServiceHosts, CMSBearerToken } = SiteConfig;

export { AuthHeader, SiteId, LoginLink, LogoutLink, WebServiceHosts, CMSBearerToken };
